export enum TranscriptionQueryTypes {
  text = 'Text',
  metadata = 'Metadata',
};

export enum TranscriptionQueryOperators {
  contains = 'Contains',
  notContains = 'NotContains',
  like = 'Like',
  notLike = 'NotLike'
};

export enum TranscriptionQueryConjunctions {
  and = 'And',
  or = 'Or',
};

export interface ITranscriptionQuery {
  text: string;
  operator?: TranscriptionQueryOperators;
  type: TranscriptionQueryTypes;
  conjuction?: TranscriptionQueryConjunctions;
};

export interface ITranscriptionQueryGroup {
  queries: ITranscriptionQuery[];
  groupConjuction?: TranscriptionQueryConjunctions;
};

export interface ITranscriptionSort {
  name: string;
  direction?: string;
};